import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import SocieteAndUserService from "../../../services/societeAndUser";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import SellingService from "../../../services/SellingService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import PurchaseService from "../../../services/PurchaseOrder";
import UploadPdfFile from "./../../../ui/UploadPdfFile";

const DevisArchived = ({ listDevis }) => {
  const navigate = useNavigate();
  console.log("listDevis", listDevis);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [clients, setClients] = useState(listDevis);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [inConfirmedDevis, setInConfirmedDevis] = useState([]);
  const [onUploadFile, setOnUploadFile] = useState(false);
  const [devisRelatedToBC, setDevisRelatedToBC] = useState([]);
  const [archivedDevis, setArchivedDevis] = useState(listDevis);
  const [devisRelatedToInvoice, setDevisRelatedToInvoice] = useState([]);
  const [devisUploadInformation, setDevisUploadInformation] = useState({
    reference: "any",
    state: 0,
    archivedDevis: archivedDevis,
  });
  const { SearchBar } = Search;
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };

  const onArchiveHandler = (refDocument, isDeleted) => {
    PurchaseService.deleteAndRestoreDevis(refDocument, isDeleted)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          window.location.reload(false);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  function buttonDeleteFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn btn-dark btn-sm"
        onClick={() => onArchiveHandler(row.reference, 0)}
      >
        <RestoreFromTrashRoundedIcon />
      </button>
    );
  }

  const onUploadFileHandler = (state, reference, isDeleted) => {
    setDevisUploadInformation({
      reference: reference,
      state: state,
      index: 0,
      devisData: archivedDevis,
      isDeleted: isDeleted,
    });
    setOnUploadFile(true);
  };
  function buttonFileFormatter(cell, row) {
    if (row.path === "any") {
      return (
        <span>
          <button
            style={{ width: 40 }}
            class="btn bg-gray btn-sm text-center"
            onClick={() =>
              onUploadFileHandler(row.state, row.reference, row.isDeleted)
            }
          >
            <i class="fas fa-plus"></i>
          </button>
        </span>
      );
    } else if (row.path !== "any") {
      return (
        <button
          style={{ width: 40 }}
          class="btn bg-gray btn-sm "
          onClick={() => onShowFileInOtherWizndowHandler(row.path)}
        >
          <i class="fas fa-eye"></i>
        </button>
      );
    }
  }

  const onAddTaxHandler = (id) => {
    sessionStorage.setItem("idTax", id);
    sessionStorage.setItem("typeToTax", "Devis");
    navigate("/addTaxAndCharge");
  };
  // function buttonChargeFormatter(cell, row) {

  //   return(<button
  //   style={{ width: 40 }}
  //   class="btn bg-gray-dark btn-sm "
  //   onClick={() => {
  //     console.log("element", row);
  //     onAddTaxHandler(row.reference);
  //   }}
  // >
  //   <i class="fas fa-plus"></i>
  // </button>)
  // }
  const onViewProductsHandler = (refDocument, NoteDocument) => {
    sessionStorage.setItem("refDocument", refDocument);
    sessionStorage.setItem("typeDocument", "devis");

    navigate("/getDocumentByRef");
  };

  function buttonDetailsFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn bg-black btn-sm "
        onClick={() => onViewProductsHandler(row.reference, row.note)}
      >
        <i class="fas fa-shopping-cart"></i>
      </button>
    );
  }
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };

  const columns = [
    {
      dataField: "reference",
      text: "Réference",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "supplierTitle",
      text: "Fournisseur",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "note",
      text: "Note",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "buyingPrice",
      text: "P.A.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "P.A.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "path",
      text: "Fichier",
      formatter: buttonFileFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },

    {
      dataField: "state",
      text: "Info",
      formatter: buttonDetailsFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "isDeleted",
      text: "Action",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div
      className="card card-outline card-dark mb-4"
      style={{ borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" }}
    >
      <div className="card-header">
        <h3 className="card-title">
          <i className="fas fa-archive mr-2"></i>Les devis d'achat archivées</h3>
      </div>
      {listDevis !== null && (
        <div className="card-body">
          <ToolkitProvider
            keyField="id"
            data={listDevis}
            columns={columns}
            onTableChange={handleTableChange}
            exportCSV
            search
          >
            {(props) => (
              <div>
                <div className="row ml-0">
                  <div>
                    <SearchBar
                      {...props.searchProps}
                      className="custome-search-field"
                      style={{ color: "black" }}
                      placeholder="Chercher"
                    ></SearchBar>
                  </div>
                  <div className="ml-auto mr-0">
                    <MyExportCSV {...props.csvProps}></MyExportCSV>
                  </div>
                </div>
                <div className="row">
                  <BootstrapTable
                    {...props.baseProps}
                    pagination={paginationFactory(options)}
                    headerClasses="thead-light"
                    wrapperClasses="table-responsive w-100"
                    striped
                    hover
                    condensed
                    //   expandRow={expandRow}
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </div>
      )}

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
      {onUploadFile && (
        <UploadPdfFile
          setOnUploadFile={setOnUploadFile}
          setInConfirmedDevis={setInConfirmedDevis}
          setDevisRelatedToBC={setDevisRelatedToBC}
          setDevisRelatedToInvoice={setDevisRelatedToInvoice}
          devisUploadInformation={devisUploadInformation}
          setArchivedDevis={setArchivedDevis}
        />
      )}
    </div>
  );
};
export default DevisArchived;
